import favicon from '../../images/icon.ico';
import { readJsonFile } from '../file/fileSystemService';
import { getSkinFolderPath } from '../../utils/contentPathUtils';

let localSkinTheme = async customerId => {
  const skinPath = getSkinFolderPath(customerId);
  return {
    colors: await readJsonFile(`${skinPath}/colors.json`),
    images: {
      icons: {
        alertSuccess: `${skinPath}/icons/success.png`,
        alertError: `${skinPath}/icons/error.png`,
        alertWarning: `${skinPath}/icons/warning.png`,
        groupColor: `${skinPath}/icons/group_color.png`,
        groupBg: `${skinPath}/icons/group_bg.png`,
        individualBg: `${skinPath}/icons/individual_bg.png`,
        individualColor: `${skinPath}/icons/individual_color.png`,
        reconnect: `${skinPath}/icons/reconnect.svg`
      },
      splashScreen: `${skinPath}/splash_screen.png`,
      headers: {
        menu: `${skinPath}/headers/header_menu.png`,
        book: `${skinPath}/headers/header_book.png`
      },
      logos: {
        favicon: favicon,
        bigLight: `${skinPath}/logos/big_light.png`,
        bigDark: `${skinPath}/logos/big_dark.png`,
        small: `${skinPath}/logos/small.png`
      },
      avatars: {
        1: `${skinPath}/avatars/avatar_01.png`,
        2: `${skinPath}/avatars/avatar_02.png`,
        3: `${skinPath}/avatars/avatar_03.png`,
        4: `${skinPath}/avatars/avatar_04.png`,
        5: `${skinPath}/avatars/avatar_05.png`,
        6: `${skinPath}/avatars/avatar_06.png`,
        7: `${skinPath}/avatars/avatar_07.png`,
        8: `${skinPath}/avatars/avatar_08.png`,
        9: `${skinPath}/avatars/avatar_09.png`,
        10: `${skinPath}/avatars/avatar_10.png`,
        11: `${skinPath}/avatars/avatar_11.png`,
        12: `${skinPath}/avatars/avatar_12.png`,
        13: `${skinPath}/avatars/avatar_13.png`,
        14: `${skinPath}/avatars/avatar_14.png`,
        15: `${skinPath}/avatars/avatar_15.png`,
        16: `${skinPath}/avatars/avatar_16.png`,
        17: `${skinPath}/avatars/avatar_17.png`,
        18: `${skinPath}/avatars/avatar_18.png`,
        19: `${skinPath}/avatars/avatar_19.png`,
        20: `${skinPath}/avatars/avatar_20.png`,
        21: `${skinPath}/avatars/avatar_21.png`,
        22: `${skinPath}/avatars/avatar_22.png`,
        23: `${skinPath}/avatars/avatar_23.png`,
        24: `${skinPath}/avatars/avatar_24.png`
      },
      classrooms: {
        1: `${skinPath}/classrooms/classroom_01.png`,
        2: `${skinPath}/classrooms/classroom_02.png`,
        3: `${skinPath}/classrooms/classroom_03.png`,
        4: `${skinPath}/classrooms/classroom_04.png`,
        5: `${skinPath}/classrooms/classroom_05.png`,
        6: `${skinPath}/classrooms/classroom_06.png`,
        7: `${skinPath}/classrooms/classroom_07.png`,
        8: `${skinPath}/classrooms/classroom_08.png`,
        9: `${skinPath}/classrooms/classroom_09.png`,
        10: `${skinPath}/classrooms/classroom_10.png`
      },
      placeholders: {
        emptyClassrooms: `${skinPath}/placeholders/placeholder_empty_classroom.png`,
        book: `${skinPath}/placeholders/placeholder_book.svg`,
        empty: `${skinPath}/placeholders/placeholder_empty.png`,
        csvIcon: `${skinPath}/placeholders/placeholder_csv.svg`,
        attachmentIcon: `${skinPath}/placeholders/attachment_icon.png`,
        authoringNotification: `${skinPath}/placeholders/authoring_notification.png`,
        lesson: {
          default: `${skinPath}/placeholders/lesson/default.svg`,
          'text/csv': `${skinPath}/placeholders/lesson/csv.svg`,
          'application/msword': `${skinPath}/placeholders/lesson/doc.svg`,
          'image/gif': `${skinPath}/placeholders/lesson/gif.svg`,
          'image/jpeg': `${skinPath}/placeholders/lesson/jpg.svg`,
          'web/resource': `${skinPath}/placeholders/lesson/link.svg`,
          'application/vnd.oasis.opendocument.presentation': `${skinPath}/placeholders/lesson/odp.svg`,
          'application/vnd.oasis.opendocument.spreadsheet': `${skinPath}/placeholders/lesson/ods.svg`,
          'application/vnd.oasis.opendocument.text': `${skinPath}/placeholders/lesson/odt.svg`,
          'application/pdf': `${skinPath}/placeholders/lesson/pdf.svg`,
          'image/png': `${skinPath}/placeholders/lesson/png.svg`,
          'application/vnd.ms-powerpoint': `${skinPath}/placeholders/lesson/ppt.svg`,
          'application/vnd.openxmlformats-officedocument.presentationml.presentation': `${skinPath}/placeholders/lesson/pptx.svg`,
          'application/vnd.ms-excel': `${skinPath}/placeholders/lesson/xls.svg`
        },
        task: {
          taskImageGroup: `${skinPath}/placeholders/task/TaskImageGroup.svg`,
          taskImageIndividual: `${skinPath}/placeholders/task/TaskImageIndividual.svg`
        }
      },
      emojis: {
        emojiAcceptableActive: `${skinPath}/emojis/acceptable_active.svg`,
        emojiAcceptableInactive: `${skinPath}/emojis/acceptable_inactive.svg`,
        emojiExcellentActive: `${skinPath}/emojis/excellent_active.svg`,
        emojiExcellentInactive: `${skinPath}/emojis/excellent_inactive.svg`,
        emojiGoodActive: `${skinPath}/emojis/good_active.svg`,
        emojiGoodInactive: `${skinPath}/emojis/good_inactive.svg`,
        emojiPoorActive: `${skinPath}/emojis/poor_active.svg`,
        emojiPoorInactive: `${skinPath}/emojis/poor_inactive.svg`,
        emojiVeryPoorActive: `${skinPath}/emojis/verypoor_active.svg`,
        emojiVeryPoorInactive: `${skinPath}/emojis/verypoor_inactive.svg`,
        emojiPending: `${skinPath}/emojis/pending.svg`
      }
    },
    layoutSettings: await readJsonFile(`${skinPath}/layout.json`),
    urlFonts: `${skinPath}/fonts.css`
  };
};

export default localSkinTheme;
